(function(EF, undefined) {

  // # EF.Models.Page
  //
  var Page = Chaplin.Model.extend({

    idAttribute: 'key',

    initialize: function(attributes, options) {
      var self = this;
      if(this.collection) {
        this.module = this.collection.module;
        this.activity = this.collection.activity;
        this.set('moduleKey', this.module.get('key'));
        this.set('activityKey', this.activity.get('key'));
      }

      this.on('change:completed', ()=> {
        if(this.get('completed')) {
          this.set('status', 'complete');
          //dont wan't event to fire for pages that changed to complete from
          //initial progress being loaded
          if(this.module && this.module.get('progressLoaded')) {
            EF.trigger('page:completed', this);
          }
          if(this.module) {
            this.module.setLastCompletedPage(this);
          }
        }
      });
    },
    // defaults must be a function because of pageData; objects in JS are passed by reference
    defaults: function() {
      return {
        completed: false,
        status: 'incomplete',
        pageData: {}
      };
    },

    getModule: function() {

      return this.collection.module;
    },

    path: function() {
      return this.get('moduleKey') + '/' + this.get('activityKey') + '/' + this.get('key');
    }

  });

  _.extend(EF.Models, {
    Page: Page
  });

})(EF);
